import { create } from "zustand";
import type { User } from "@/types";
import { isWhale } from "@/config/vip";

interface UserState {
  user: User | null;
  isLoading: boolean;
  credits: number;
  hasPurchased: boolean;
  accTier: number;
  isWhale: boolean;
  vipAtRisk: boolean;
  generationsPurgeInDays: number | null;
  daysSincePurchase: number | null;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  updateCredits: (credits: number) => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  isLoading: true,
  credits: 0,
  hasPurchased: false,
  accTier: 0,
  isWhale: false,
  vipAtRisk: false,
  generationsPurgeInDays: null,
  daysSincePurchase: null,
  setUser: (user) =>
    set({
      user,
      credits: user?.credit_balance ?? 0,
      hasPurchased: !!user?.highest_package,
      accTier: user?.acc_tier ?? 0,
      isWhale: user?.is_whale ?? isWhale(user?.purchase_count),
      vipAtRisk: user?.vip_at_risk ?? false,
      generationsPurgeInDays: user?.generations_purge_in_days ?? null,
      daysSincePurchase: user?.days_since_purchase ?? null,
    }),
  setLoading: (isLoading) => set({ isLoading }),
  updateCredits: (credits) =>
    set((state) => ({
      credits,
      user: state.user ? { ...state.user, credit_balance: credits } : null,
    })),
}));
